import style from "./Accordion.module.css";
import { ChevronUp,ChevronDown } from "../../asset";
const Accordion = (props) => {
  return (
    <>
      <div className="p-5 h-auto mr-10" style={{ marginBottom: "20px", width: `${props.width ? props.width :"1300px"}` }}>
        <div className={style.containerAcordion} >
          <div className={style.mainAcordion}>
            <div className={style.containerHeader}>
              {/* {props.show && props.code === props.data.id && (
                <>{props.data.level}</>
              )} */}
              <div className={`${props.isMenu==="shippingcost" ? "font-medium font-roboto h-[40px] text-[18px]":style.Name}`}>{props.radio ? props.radio :""}{props?.address ? props?.address : "Address " + (props?.index+1)}{props.sup}</div>
            </div>
            <div className={style.containerMain}>
              <div className={style.containerViewDetail}>
                {/* <Link to={{ pathname: ROUTES.PRODUCT_GROUP_HIERARCHY.DETAIL, 
                      state: { id: props.data.id } }}>
                        {props.t("COMMON:VIEW_DETAIL")}
                    </Link> */}
              </div>
              <div className={style.containerIcon}>
                <div 
                // onClick={props.child}
                 className="cursor-pointer mr-10" onClick={()=>props.onClick()}>
                  {props.isOpen && props.i === props.index ? 
                        <img src={ChevronDown} alt="arrowUp" className="w-9"/> 
                          : 
                          <img src={ChevronUp} alt="arrowDown" className="w-9" /> }
                    </div>
                </div>
              </div>
            </div>
            
          {props.body}
          </div>
        </div>
    </>
  );
};
export default Accordion;
